<template>
    <b-container class='page-container'>
        <b-row>
            <b-col sm='12'>
                <b-card title='Bet History'>
                    <b-table :items='picks' :fields='fields' :busy='isBusy' responsive>
                        <template #table-busy>
                            <div class="text-center text-info my-2">
                                <b-spinner class="align-middle" variant='info'></b-spinner>
                                <strong>Loading...</strong>
                            </div>
                        </template>

                        <template #cell(created)="data">
                            {{ new Date(data.item.created).toLocaleString().replace(/:\d{2} /, ' ') }}
                        </template>

                        <template #cell(type)="data">
                            {{ data.item.isParlay ? "Parlay" : "Single Game" }}
                        </template>

                        <template #cell(events)="data">
                            <div v-for='game in data.item.games' class='text-left'>
                                {{ game.pick }} {{ game.line | sportsline }} <span
                                    v-if='data.item.outcome'>({{ game.pick }} {{ game.pickScore }},
                                    {{ game.opponent }} {{ game.oppScore }})</span><span v-else>(vs
                                    {{game.opponent}})</span>
                            </div>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    export default {
        name: 'History',
        data() {
            return {
                isBusy: false,
                picks: [],
                fields: [{
                    key: 'created',
                    label: 'Date'
                }, {
                    key: 'type',
                    label: 'Type'
                }, {
                    key: 'events',
                    label: 'Events'
                }, {
                    key: 'risk',
                    label: 'Risk'
                }, {
                    key: 'outcome',
                    label: 'Outcome'
                }]
            };
        },
        created() {
            this.isBusy = true;
            this.$axios.get('/api/player/history').then(results => {
                this.picks = results.data;
                for (let pick of this.picks) {
                    if (pick.outcome && parseFloat(pick.outcome) < 0) {
                        pick._rowVariant = 'danger';
                    } else if (pick.outcome && parseFloat(pick.outcome) > 0) {
                        pick._rowVariant = 'success';
                    }
                }
            }).finally(() => {
                this.isBusy = false;
            });
        }
    }

</script>

<style lang='scss'>

</style>
